import React, { useContext, useEffect, useState } from 'react';
import axios from "axios";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { brandLogo } from '../../../constants/brandAssets';
import coupleImage from '../../../assets/images/couples/Vector.png';
import { LoginContext } from '../../../context/LoginContext';
import Header from '../Header';
import Footer from '../Footer';


const parseMultiSelectValue = (val) => {
  if (!val) return [];
  if (Array.isArray(val)) return val.filter(Boolean);
  if (typeof val === 'string') {
    const trimmed = val.trim();
    if (!trimmed) return [];
    return trimmed
      .split(',')
      .map((s) => {
        const item = s.trim();
        return { label: item, value: item };
      })
      .filter((item) => item.value);
  }
  if (typeof val === 'object') return [val];
  return [];
};

const formatMultiValueString = (val) => {
  if (!val) return '';
  if (Array.isArray(val)) {
    return val
      .map((item) => (typeof item === 'object' ? item.value || item.label : String(item).trim()))
      .filter(Boolean)
      .join(', ');
  }
  if (typeof val === 'object') return val.value || val.label || '';
  return String(val).trim();
};

const formatSingleValueString = (val) => {
  if (!val) return '';
  if (typeof val === 'object') return val.value || val.label || '';
  return String(val).trim();
};

const toSelectOption = (val) => {
  if (val && typeof val === 'object') {
    const lbl = Object.values(val)[0] || Object.keys(val)[0] || '';
    const v = Object.keys(val)[0] || lbl;
    return { label: String(lbl), value: String(v) };
  }
  return { label: String(val), value: String(val) };
};

const EditPartner = () => {
  // Form data state

  const navigate = useNavigate();

  const { userId, userName, userData, isLoggedIn } = useContext(LoginContext);
  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState({
    min_age: { label: 21, value: 21 },
    max_age: { label: 40, value: 40 },
    min_height: { label: `4.0 Ft`, value: `4.0` },
    max_height: { label: `6.0 Ft`, value: `6.0` },
    maritalStatus: "",
    country: { label: "India", value: "India" },
    state: "",
    caste: "",
    language: "",
    highestEducation: "",
    occupation: "",
    income: ""
  });

  // Options data state
  const [options, setOptions] = useState({
    caste: [],
    gothra: [],
    cities: [],
    countries: [],
    income: [],
    message: [],
    states: [],
    language: [],
    occupation: []
  });

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch all dropdown options
  useEffect(() => {

    if (!isLoggedIn) {
      navigate("/login");
    }


    const payload = new FormData();
    payload.append("id", userId);
    payload.append("looking", userData.looking_for);
    payload.append("gender", userData.gender);
    payload.append("status", userData.status);
    payload.append("email", userData.email);

    const fetchOptions = async () => {
      try {
        setIsLoading(true);
        setError(null);

        const partnerUser = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}mycon/desired_partner`,
          payload
        );


        if (partnerUser.data.response == "success" && partnerUser.data.details) {
          let dpres = partnerUser.data.details;
          let newAge = dpres.age ? String(dpres.age).split(",") : ["21", "40"];
          let newHeight = dpres.height ? String(dpres.height).split(",") : ["4.0", "6.0"];
          setFormData({
            min_age: { label: parseInt(newAge[0]) || 21, value: parseInt(newAge[0]) || 21 },
            max_age: { label: parseInt(newAge[1] || newAge[0]) || 40, value: parseInt(newAge[1] || newAge[0]) || 40 },
            min_height: { label: `${newHeight[0] ? newHeight[0].trim() : '4.0'} Ft`, value: newHeight[0] ? newHeight[0].trim() : '4.0' },
            max_height: { label: `${newHeight[1] ? newHeight[1].trim() : (newHeight[0] ? newHeight[0].trim() : '6.0')} Ft`, value: newHeight[1] ? newHeight[1].trim() : (newHeight[0] ? newHeight[0].trim() : '6.0') },
            maritalStatus: dpres.marital_status || '',
            country: dpres.country ? { label: dpres.country, value: dpres.country } : { label: "India", value: "India" },
            state: dpres.state || '',
            caste: dpres.caste || '',
            language: dpres.mother_tongue || '',
            highestEducation: dpres.highest_education ? { label: dpres.highest_education, value: dpres.highest_education } : { label: "Doesn't Matter", value: "Doesn't Matter" },
            occupation: dpres.occupation || '',
            income: dpres.income && parseInt(dpres.income.income) ? { label: dpres.income.name, value: parseInt(dpres.income.income) } : { label: "Doesn't Matter", value: "Doesn't Matter" },
          });
        }



        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}admin-mat/api/caste.php`
        );

        const resp = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}admin-mat/api/education.php`
        );



        if (!response.data.success) {
          throw new Error(response.data.error || "Failed to fetch options");
        }

        // Transform all options to ensure they're arrays
        const transformedOptions = {
          caste: Array.isArray(response.data.data.caste) ? response.data.data.caste : [],
          gothra: Array.isArray(response.data.data.gothra) ? response.data.data.gothra : [],
          cities: Array.isArray(response.data.data.cities) ? response.data.data.cities : [],
          countries: Array.isArray(response.data.data.countries) ? response.data.data.countries : [],
          income: Array.isArray(response.data.data.income) ? response.data.data.income : [],
          message: Array.isArray(response.data.data.message) ? response.data.data.message : [],
          states: Array.isArray(response.data.data.states) ? response.data.data.states : [],
          language: Array.isArray(response.data.data.language) ? response.data.data.language : [],
          occupation: Array.isArray(resp.data.data.occupation) ? resp.data.data.occupation : []
        };

        setOptions(transformedOptions);
      } catch (err) {
        console.error("Error fetching options:", err);
        setError(err.message);
        // Initialize with empty arrays if request fails
        setOptions({
          caste: [],
          gothra: [],
          cities: [],
          countries: [],
          income: [],
          message: [],
          states: [],
          language: [],
          occupation: []
        });
      } finally {
        setIsLoading(false);
      }

    };

    fetchOptions();
  }, [userId]);

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Handle select changes
  const handleSelectChange = (name, selectedOption) => {
    setFormData(prev => ({
      ...prev,
      [name]: selectedOption
    }));
  };

  const validateForm = () => {
    /////after Fill Validate form
    const newErrors = {};

    if (!formData.min_age) newErrors.min_age = "MIN Age is Required";
    if (!formData.max_age) newErrors.max_age = "MIN Age is Required";
    if (!formData.min_height) newErrors.min_height = "MIN Height is Required";
    if (!formData.max_height) newErrors.max_height = "MAX Height is Required";
    if (!formData.maritalStatus) newErrors.maritalStatus = "Martial Status is Required";
    if (!formData.country) newErrors.country = "Country is Required";
    if (!formData.state) newErrors.state = "State is Required";
    if (!formData.caste) newErrors.caste = "Caste is Required";
    if (!formData.language) newErrors.language = "language is Required";
    if (!formData.highestEducation) newErrors.highestEducation = "Highest is Required";
    if (!formData.occupation) newErrors.occupation = "Occupation is Required";
    if (!formData.income) newErrors.income = "Income is Required";


    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  }

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      const payload = new FormData();

      payload.append("id", userId);
      payload.append("age", `${formData.min_age?.value || formData.min_age || 21}, ${formData.max_age?.value || formData.max_age || 40}`);
      payload.append("height", `${formData.min_height?.value || formData.min_height || '4.0'}, ${formData.max_height?.value || formData.max_height || '6.0'}`);
      payload.append("ms", formatMultiValueString(formData.maritalStatus));
      payload.append("country", formatSingleValueString(formData.country));
      payload.append("state", formatMultiValueString(formData.state));
      payload.append("caste", formatMultiValueString(formData.caste));
      payload.append("motherTongue", formatMultiValueString(formData.language));
      payload.append("h_education", formatSingleValueString(formData.highestEducation));
      payload.append("occupation", formatMultiValueString(formData.occupation));
      payload.append("income", formatSingleValueString(formData.income));



      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}Register_controller/updateDpDetails`,
        payload
      );


      if (response.data.response === "success") {
        ///use context api 
        navigate('/view-profile/' + userId);
      }

    } catch (error) {
      console.log('Error While Posting Data:', error);
    }


  };

  if (isLoading) {
    return (<div className='custom-loader-g'><div class="spinner-border text-danger" role="status"><span class="sr-only">Loading...</span></div></div>);
  }

  if (error) {
    return <div className="error">Error: {error}</div>;
  }

  return (


    <>

      <Header></Header>

      <div className='create-profile-wrapper'>

        <div className='container'>
          <div className="create-profile-container">
            {/* Left Side Form */}
            <div className="create-profile-form-side py-4">
              <h1 className="create-profile-heading text-center mb-0">Edit Desired Partner</h1>
              {/* <p className="create-profile-subheading text-center">Start your journey here</p> */}

              <form className="create-profile-form" onSubmit={handleSubmit}>
                {/* Section 1: Basic Details */}
                <h3 className="form-section-title text-center my-0">Basic Details</h3>



                <div className="form-row" style={{flexDirection:"row"}}>
                  <div className="form-group">
                    <label className="form-label">Min Age *</label>


                    <Select
                      options={Array.from({ length: 40 }, (_, i) => (21 + (i))).map(val => ({
                        label: val,
                        value: val
                      }))}
                      value={formData.min_age}
                      onChange={(selected) => handleSelectChange("min_age", selected)}

                    />

                    {errors.min_age && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.min_age}</span>}

                  </div>
                  <div className="form-group">
                    <label className="form-label">Max Age *</label>

                    <Select
                      options={Array.from({ length: 40 }, (_, i) => (21 + (i))).map(val => ({
                        label: val,
                        value: val
                      }))}
                      value={formData.max_age}
                      onChange={(selected) => handleSelectChange("max_age", selected)}
                      defaultValue={{ label: 40, value: 40 }}
                    />

                    {errors.max_age && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.max_age}</span>}

                  </div>
                </div>



                <div className="form-row"  style={{flexDirection:"row"}}>

                  <div className="form-group">
                    <label className="form-label">Min Height *</label>


                    <Select
                      options={Array.from({ length: 4 }, (_, f) => 4 + f) // 4 to 7
                        .flatMap(feet =>
                          Array.from({ length: 12 }, (_, inches) => {
                            if (feet === 7 && inches > 0) return null;
                            return { label: `${feet}.${inches} Ft`, value: `${feet}.${inches}` }
                          }).filter(Boolean)
                        )}
                      value={formData.min_height}
                      onChange={(selected) => handleSelectChange("min_height", selected)}
                      placeholder="Select Min Height"

                    />

                    {errors.min_height && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.min_height}</span>}

                  </div>

                  <div className="form-group">
                    <label className="form-label">Max Height *</label>


                    <Select
                      options={Array.from({ length: 4 }, (_, f) => 4 + f) // 4 to 7
                        .flatMap(feet =>
                          Array.from({ length: 12 }, (_, inches) => {
                            if (feet === 7 && inches > 0) return null;
                            return { label: `${feet}.${inches} Ft`, value: `${feet}.${inches}` }
                          }).filter(Boolean)
                        )}
                      value={formData.max_height}
                      onChange={(selected) => handleSelectChange("max_height", selected)}
                      placeholder="Select Max Height"

                    />

                    {errors.max_height && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.max_height}</span>}

                  </div>

                </div>


                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">Marital Status *</label>

                    <Select
                      options={["Single", "Divorced", ((userData.gender === 'Female' || userData.looking_for === 'Groom') ? "Widower" : "Widowed")].map(val => ({
                        label: val,
                        value: val
                      }))}
                      value={parseMultiSelectValue(formData.maritalStatus)}
                      onChange={(selected) => handleSelectChange("maritalStatus", selected)}
                      placeholder="Select Marital Status"
                      isMulti
                    />

                    {errors.maritalStatus && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.maritalStatus}</span>}

                  </div>

                </div>


                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">Country : </label>

                    <Select
                      options={options?.countries?.map(val => ({
                        label: val,
                        value: val
                      }))}
                      value={formData.country}
                      onChange={(selected) => handleSelectChange("country", selected)}
                      placeholder="Select Country"

                    />

                    {errors.country && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.country}</span>}

                  </div>
                  <div className="form-group">
                    <label className="form-label">State : </label>


                    <Select
                      options={options?.states?.map(toSelectOption)}
                      value={parseMultiSelectValue(formData.state)}
                      onChange={(selected) => handleSelectChange("state", selected)}
                      placeholder="Select State"
                      isMulti
                    />

                    {errors.state && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.state}</span>}

                  </div>
                </div>



                <h3 className="form-section-title text-center my-2"> Religion & Ethnicity</h3>


                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">Religion : </label>

                    <Select
                      options={Array("Hindu").map(val => ({
                        label: val,
                        value: val
                      }))}
                      value={formData.religion}
                      onChange={(selected) => handleSelectChange("religion", selected)}
                      placeholder="Select Religion"
                      defaultValue={{ label: "Hindu", value: "Hindu" }}
                    />

                  </div>
                  <div className="form-group">
                    <label className="form-label">Caste : * </label>


                    <Select
                      options={options?.caste?.map(toSelectOption)}
                      value={parseMultiSelectValue(formData.caste)}
                      onChange={(selected) => handleSelectChange("caste", selected)}
                      placeholder="Select Caste"
                      isMulti
                    />
                    {errors.caste && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.caste}</span>}

                  </div>

                </div>


                <div className="form-row">

                  <div className="form-group">
                    <label className="form-label">Mother Tounge / Language : * </label>

                    <Select
                      options={options?.language ? [...options.language].sort((a, b) => a === 'Other' ? 1 : b === 'Other' ? -1 : a.localeCompare(b)).map(toSelectOption) : []}
                      value={parseMultiSelectValue(formData.language)}
                      onChange={(selected) => handleSelectChange("language", selected)}
                      placeholder="Select Language"
                      isMulti
                    />
                    {errors.language && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.language}</span>}

                  </div>

                </div>








                {/* Section 2: Education & Career */}
                <h3 className="form-section-title text-center my-2">Education & Career</h3>

                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">Highest Education *</label>


                    <Select
                      options={Array("Doesn't Matter", "10th Pass", "12th Pass", "Diploma", "Graduate", "Post Graduate", "M Phil", "PHD", "Other").map(val => ({
                        label: val,
                        value: val
                      }))}
                      value={formData.highestEducation}
                      onChange={(selected) => handleSelectChange("highestEducation", selected)}
                      placeholder="Select Highest Education"
                    />
                    {errors.highestEducation && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.highestEducation}</span>}

                  </div>

                  <div className="form-group">
                    <label className="form-label">Occupation *</label>

                    <Select
                      options={[{ label: "Doesn't Matter", value: "Doesn't Matter" }, ...(options?.occupation?.map(toSelectOption) || [])]}
                      value={parseMultiSelectValue(formData.occupation)}
                      onChange={(selected) => handleSelectChange("occupation", selected)}
                      placeholder="Select Occupation"
                      isMulti
                    />

                    {errors.occupation && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.occupation}</span>}

                  </div>

                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">Annual Income *</label>


                    <Select
                      options={[{ label: "Doesn't Matter", value: "Doesn't Matter" }, ...options?.income?.map((val, index) => ({
                        label: val,
                        value: (index + 1)
                      }))]}
                      value={formData.income}
                      onChange={(selected) => handleSelectChange("income", selected)}
                      placeholder="Select Annual Income"
                    />

                    {errors.income && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.income}</span>}

                  </div>

                </div>





                <button type="submit" className="create-btn mt-3">Update</button>
              </form>
            </div>

            {/* Right Side Image */}
            <div className="create-profile-image-side d-none d-lg-block">
              <img src={coupleImage} alt="Couple" className="couple-image" />
              <div className="image-overlay">
                <h2 className="overlay-heading text-white fw-bold">
                  Your Journey To Love Begins <span className="highlight">Here!</span>
                </h2>
                <p className="overlay-text text-white fw-bold">
                  Connect With Genuine Matches Who Share <br/> Your <span className="highlight">Values</span> And <span className="highlight">Dreams</span>.
                </p>
              </div>
            </div>
          </div>
        </div>

        <style>
          {`
        /* Main Layout */

        .form-group select,.form-group input
        {
        background:white;
        border-radius:15px;
        }
        .create-profile-wrapper {
          min-height: 100vh;
          background-color: #fff;
        }

        .create-profile-logo {
          max-width: 180px;
          margin: 20px;
        }

        .create-profile-container {
          display: flex;
          height: calc(100vh - 80px);
          overflow: hidden;
          background:white;
          border-radius:16px;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
          margin-top:30px;
        }

        /* Form Side Styles */
        .create-profile-form-side {
          width: 60%;
          padding: 40px;
          overflow-y: auto;
          background-color: #fff;
        }

        .create-profile-heading {
          font-size: 2rem;
          color: #333;
          margin-bottom: 0.5rem;
        }

        .create-profile-subheading {
          color: #666;
          margin-bottom: 0;
          font-size: 1rem;
        }

        .create-profile-form {
          display: flex;
          flex-direction: column;
          gap: 0;
        }

        .form-section-title {
          margin-top: 2rem;
          color: #E53D5C;
          font-size: 1.3rem;
          font-weight: 600;
        }

        /* Form Elements */
        .form-group {
          display: flex;
          flex-direction: column;
        }

        .form-label {
          font-size: 0.9rem;
          font-weight: 500;
          color: #333;
        }

        .form-input,
        .form-select,
        .form-textarea {
          padding: 0.8rem;
          border-radius: 6px;
          border: 1px solid #ccc;
          font-size: 1rem;
          transition: border-color 0.2s;
        }

        .form-input:focus,
        .form-select:focus,
        .form-textarea:focus {
          outline: none;
          border-color: #E53D5C;
        }

        .form-textarea {
          min-height: 100px;
          resize: vertical;
        }

        .form-row {
          display: flex;
          gap: 3px 15px;
        }

        .form-row > .form-group {
          flex: 1;
        }

        /* Image Side Styles */
        .create-profile-image-side {
          width: 40%;
          position: relative;
          background-color: #F8E1E7;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }

        .couple-image {
          width: 100%;
          margin-bottom: 20px;
        }

        .image-overlay {
          text-align: center;
          position: absolute;
  bottom: 40px;
  width: 100%;
  padding:20px;
        }

        .overlay-heading {
          font-size: 1.8rem;
          color: #333;
          margin-bottom: 1rem;
          line-height: 1.3;
        }

        .overlay-text {
          font-size: 1rem;
          color: #666;
          line-height: 1.6;
        }

        .highlight {
          color: #ffc107;
          font-weight: 600;
        }

        .create-btn {
          padding: 12px;
          background-color: #ff4d6d;
          color: white;
          border: none;
          border-radius: 6px;
          font-weight: bold;
          cursor: pointer;
          width: 100%;
          margin-top: 2rem;
        }

        .loading, .error {
          padding: 2rem;
          text-align: center;
          font-size: 1.2rem;
        }

        .error {
          color: #E53D5C;
        }

        /* Responsive styles */
        @media (max-width: 768px) {
          .create-profile-container {
            flex-direction: column;
            height: auto;
          }
          
          .create-profile-form-side,
          .create-profile-image-side {
            width: 100%;
            padding:0 15px;
          }
          
          .form-row {
            flex-direction: column;
            gap: 0 15px;
          }
            .css-13cymwt-control {
            border-color: #FF4D6D !important ;
            }
          .css-13cymwt-control:hover {
            
            }
        }
        `}
        </style>
      </div>

      <Footer></Footer>
    </>
  );
};

export default EditPartner;